const contentWrapperCls = "_275c1otqkq";
const createTeamButton = "_275caepi1u";
const tableHeading = "_275t1xprzgi";

export { contentWrapperCls, createTeamButton, tableHeading };
import "./_page.style.linaria.module.css";
//# sourceMappingURL=_page.style.js.map
